import { getConfidenceClass } from "../../Document/getConfidenceClass";
import { State } from "../../types";
import { normalizeValues } from "../getDefaultState";

export type ClearGroupAction = Readonly<{
  key: string;
  type: "CLEAR GROUP";
}>;

export const clearGroup = (state: State, action: ClearGroupAction): State => {
  const keyFilterPrefix = `${action.key}.`;
  const relevantKeys = Object.keys(state.values).filter(k => k.startsWith(keyFilterPrefix));
  if (relevantKeys.length < 1) {
    return state;
  }
  const updatedBlocks: State["blocks"] = {};
  const values = normalizeValues(
    state.taxonomy.taxonomyObject,
    relevantKeys.reduce(
      (prev, next): State["values"] => {
        const idRef = prev[next].idRef;
        if (idRef && idRef in state.blocks) {
          const block = state.blocks[idRef];
          if (block.references.includes(next)) {
            if (!(idRef in updatedBlocks)) {
              updatedBlocks[idRef] = state.blocks[idRef];
            }
            updatedBlocks[idRef] = {
              ...updatedBlocks[idRef],
              references: updatedBlocks[idRef].references.filter(r => r !== next),
              // This is a hack, we would have to somehow track which highlight
              // belongs to each reference, but for most cases this will suffice
              highlights: updatedBlocks[idRef].highlights.filter(highlight => {
              state.values[next].value !== highlight && state.values[next].valueRaw !== highlight
            })
            };
          }
        }
        delete prev[next];
        return prev;
      },
      { ...state.values },
    ),
  );
  let blocks = state.blocks;
  if (Object.keys(updatedBlocks).length > 0) {
    // merge the new updated blocks into the state and recalculate their confidence classes
    blocks = {
      ...blocks,
      ...Object.keys(updatedBlocks).reduce((prev, next) => {
        prev[next] = {
          ...prev[next],
          confidenceClass: getConfidenceClass(prev[next], state.confidenceThreshold, values),
        };
        return prev;
      }, updatedBlocks),
    };
  }
  let activeValue = state.activeValue;
  if (relevantKeys.includes(activeValue)) {
    activeValue = "";
  }
  return {
    ...state,
    activeValue,
    blocks,
    values,
  };
};
